import { render, staticRenderFns } from "./SegTablaSolicitud.vue?vue&type=template&id=030e0584&scoped=true&"
import script from "./SegTablaSolicitud.vue?vue&type=script&lang=js&"
export * from "./SegTablaSolicitud.vue?vue&type=script&lang=js&"
import style0 from "./SegTablaSolicitud.vue?vue&type=style&index=0&id=030e0584&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "030e0584",
  null
  
)

export default component.exports